import { rem } from 'polished';
import styled from 'styled-components';
import { hoverMediaQuery, mediaQueryWidth, noHoverMediaQuery, widthBreakpoints } from '../../../common/breakpoints';
import { black, white } from '../../../common/colors';
import { safeBGImageUrl } from '../../../common/helpers/strings';

const desktopHeightPx = 780;
const minimumBannerWidthPx = 512;

export const FeatureContainer = styled.div`
  position: relative;
  width: 100%;
  background: ${black};
  padding-bottom: calc(0.4 * (${widthBreakpoints.mobile}px - 100%) + 25px);

  ${mediaQueryWidth({ min: 'mobile', max: 'tablet' })`
    padding-bottom: calc(.17 * (${widthBreakpoints.tablet}px - 100%) + 90px);
  `}

  ${mediaQueryWidth({ min: 'tablet' })`
    display: inline-block;
    flex: 1 0 ${minimumBannerWidthPx}px;
    vertical-align: top;
  `}

  ${mediaQueryWidth({ min: 'tablet', max: 'hd' })`
    // Styles needed for IE to properly determine container bottom
    height: ${desktopHeightPx}px;
    box-sizing: border-box;
  `}

  ${mediaQueryWidth({ min: 'hd' })`
    padding-bottom: 150px;
  `}
`;

export const FeatureImage = styled.div<{ src: string }>`
  background-image: ${({ src }) => safeBGImageUrl(src)};
  background-position: top;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-color: ${black};
  padding-bottom: 110%;

  ${mediaQueryWidth({ min: 'mobile', max: 'tablet' })`
    padding-bottom: 70%;
  `};

  ${mediaQueryWidth({ min: 'tablet', max: 'hd' })`
    padding-bottom: ${desktopHeightPx}px;
  `}

  ${mediaQueryWidth({ min: 'hd' })`
    padding-bottom: 50%;
  `}
`;

export const FeatureLogoImage = styled.img`
  position: absolute;
  z-index: 1;
  top: 12px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 18.75%;
  min-width: 60px;

  ${mediaQueryWidth({ min: 'mobile' })`
    top: 20px;
    width: 120px;
  `}
`;

export const FeatureLogoIconContainer = styled.div`
  position: absolute;
  z-index: 1;
  top: 12px;
  width: 100%;
  text-align: center;
  color: ${white};

  svg {
    width: 18.75%;
    min-width: 60px;
  }

  ${mediaQueryWidth({ min: 'mobile' })`
    top: 20px;

    svg {
      width: 120px;
    }
  `}
`;

export const FeatureContent = styled.div`
  border-left: 0.1rem solid #a1a1a1;
  border-left: 0.1rem solid rgba(255, 255, 255, 0.3);
  text-align: left;
  padding: 0 5px 0 15px;

  ${mediaQueryWidth({ min: 'mobile' })`
    padding: 0 0 0 50px;
  `}
`;

export const FeatureContentContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 0 40px 20px;

  ${mediaQueryWidth({ min: 'mobile' })`
    padding: 0 50px 50px 50px;
  `}
`;

export const FeatureContentHeader = styled.header``;

export const FeatureContentLink = styled.a`
  display: inline-block;
  color: ${white};
  text-decoration: none;
  text-shadow: rgba(0, 0, 0, 0.5) -1px -1px 3px, rgba(0, 0, 0, 0.5) 1px -1px 3px, rgba(0, 0, 0, 0.5) -1px 1px 3px,
    rgba(0, 0, 0, 0.5) 1px 1px 3px;

  ${hoverMediaQuery} {
    &:hover {
      color: dodgerblue;
    }
  }

  ${noHoverMediaQuery} {
    &:active {
      color: dodgerblue;
    }
  }
`;

export const FeatureContentSuperTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-size: ${rem(12)};
  font-weight: 500;
  line-height: ${rem(15)};
  color: inherit;
  text-transform: none;
  white-space: nowrap;

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(20)};
    line-height: ${rem(24)};
  `}
`;

export const FeatureContentTitle = styled.div`
  font-size: ${rem(25)};
  font-weight: 800;
  line-height: ${rem(30)};
  text-transform: uppercase;

  & > div {
    white-space: nowrap;
  }

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(46)};
    line-height: ${rem(60)};
  `}
`;

export const FeatureContentButtonContainer = styled.div`
  && > * {
    text-align: center;
    margin: 20px 15px 0 0;

    ${mediaQueryWidth({ min: 'mobile' })`
      margin: 20px 20px 0 0;
    `}
  }
`;
